import React, { Component } from 'react';
import DefaultGrid from '../../../components/DefaultGrid';
import CrudForm from '../../../template/CrudForm';
import Form, { SimpleItem, GroupItem } from 'devextreme-react/form';
import API from '../../../services/AplicationService';
import {
	showSuccessMessage,
	showConfirmationMessage,
	handleError,
	showInfoMessage,
	formatCPF,
} from '../../../utils/Utility';
import * as messages from '../../../utils/Messages';
import '../../../utils/Messages';
import * as defaultData from '../../../utils/DefaultData';

const masterProps = {
	title: 'Cadastro de Usuários',
	subtitle: 'Gerencie o cadastro de usuários',
};
const initialState = {
	user: {
		id: null,
		name: '',
		email: '',
		role: '',
		document: '',
		enabled: true,
		contactInformation: {
			id: '',
			name: '',
			phoneNumber: '',
			homePhoneNumber: '',
			businessPhoneNumber: '',
		},
	},
	term: '',
};
export default class User extends Component {
	state = { ...initialState };
	user = {
		id: null,
		name: '',
		description: '',
		document: '',
		enabled: true,
		contactInformation: {
			id: '',
			name: '',
			phoneNumber: '',
			homePhoneNumber: '',
			businessPhoneNumber: '',
		},
	};
	constructor(props) {
		super(props);
		this.loadListUsers = this.loadListUsers.bind(this);
		this.getUser = this.getUser.bind(this);
		this.deleteUser = this.deleteUser.bind(this);
		this.onClickSearch = this.onClickSearch.bind(this);
		this.onClickNew = this.onClickNew.bind(this);
		this.onClickSave = this.onClickSave.bind(this);
		this.onSendEmail = this.onSendEmail.bind(this);
		this.setStateDataToInitial = this.setStateDataToInitial.bind(this);
		this.sendEmailChangePassword = this.sendEmailChangePassword.bind(this);
		this.saveUser = this.saveUser.bind(this);
		this.dataGrid = React.createRef();
		this.crudForm = React.createRef();
		this.form = React.createRef();
	}
	getUser(key) {
		this.crudForm.current.showLoadingPanel(true);
		API.get('users/' + key)
			.then(response => {
				this.user = { ...response.data };
				this.setState({ ...this.state, user: this.user });
				this.crudForm.current.setActiveTabIndex(1);
			})
			.catch(error => {
				handleError(error, messages.errorGetData);
			})
			.then(() => {
				this.crudForm.current.showLoadingPanel(false);
			});
	}
	deleteUser(key) {
		API.delete('users/' + key)
			.then(response => {
				showSuccessMessage(messages.successDeleteData);
				this.setStateDataToInitial();
				this.dataGrid.current.reloadData();
			})
			.catch(error => {
				handleError(error, messages.errorDeleteData);
			});
	}
	sendEmailChangePassword(key) {
		this.crudForm.current.showLoadingPanel(true);
		API.get('account/sendEmailPassword/' + key)
			.then(response => {
				showInfoMessage('E-mail de boas vindas ou alteração de senha enviado com sucesso! Verifique a caixa de spam do seu e-mail.');
			})
			.catch(error => {
				handleError(error, messages.errorGetData);
			})
			.then(() => {
				this.crudForm.current.showLoadingPanel(false);
			});
	}
	saveUser() {
		this.crudForm.current.showLoadingPanel(true);
		let user = { ...this.user };
		if (user.id === null) {
			API.post('users/', user)
				.then(response => {
					showSuccessMessage(messages.successInsertData);
					user = response.data;
					this.user = user;
					this.setState({ user: this.user });
					// console.log(this.user);
					//this.setStateDataToInitial();
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorInsertData);
					this.dataGrid.current.reloadData();
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		} else {
			API.put('users/' + user.id, user)
				.then(response => {
					showSuccessMessage(messages.successUpdateData);
					this.user = user;
					this.setState({ user: this.user });
					this.dataGrid.current.reloadData();
				})
				.catch(error => {
					handleError(error, messages.errorUpdateData);
				})
				.then(() => {
					this.crudForm.current.showLoadingPanel(false);
				});
		}
	}
	loadListUsers(page, pageSize) {
		let term = this.state.term;
		return API.get('/users', {
			params: {
				page: page,
				pageSize: pageSize,
				term: term,
			},
		})
			.then(response => {
				let result = {
					data: response.data.users,
					totalCount: response.data.totalRegisters,
				};

				return result;
			})
			.catch(error => {
				handleError(error, messages.errorListData);
			});
	}
	renderGrid() {
		return (
			<React.Fragment>
				<DefaultGrid
					ref={this.dataGrid}
					pageSize={50}
					keyField={'id'}
					showBorders={true}
					fncDeleteData={this.deleteUser}
					fncGetData={this.getUser}
					fncListData={this.loadListUsers}
					defaultColumns={[
						{ dataField: 'id', caption: 'Código', width: '5%' },
						{
							dataField: 'document',
							caption: 'CPF',
							width: '20%',
							datatType: 'text',
							calculateCellValue: function(data) {
								return formatCPF(data.document);
							},
						},
						{ dataField: 'name', caption: 'Nome' },
						{ dataField: 'email', caption: 'Email' },
						{ dataField: 'role', caption: 'Perfil Acesso' },
						{ dataField: 'enabled', caption: 'Ativo', width: '10%' },
					]}
					buttons={[
						{
							name: 'edit',
							hint: 'delete',
							icon: 'fa fa-edit',
							visible: true,
						},
						{
							name: 'delete',
							hint: 'Excluir',
							icon: 'fa fa-trash',
							visible: true,
						},
						{
							hint: 'Enviar E-mail de Senha',
							icon: 'fa fa-envelope-square',
							visible: true,
							onClick: this.onSendEmail,
						},
					]}
				/>
			</React.Fragment>
		);
	}
	setStateDataToInitial() {
		this.user = { ...initialState.user };
		this.setState({ ...this.state, user: this.user });
	}
	onClickSearch = function(e) {
		this.dataGrid.current.reloadData();
	};
	onSendEmail = function(e) {
		this.sendEmailChangePassword(e.row.data.email);
		// this.onSendEmail();
	};
	onClickSave = function() {
		this.saveUser();
	};
	onClickNew = function() {
		showConfirmationMessage(messages.questionNewOperation, this.setStateDataToInitial);
	};
	renderFilter() {
		return (
			<Form formData={this.state} colCount={7}>
				<GroupItem colSpan={6}>
					<SimpleItem
						dataField={'term'}
						cssClass="uppercase"
						editorOptions={{ placeholder: 'Digite o que deseja procurar...' }}
						label={{ text: 'Buscar por', showColon: false, visible: false }}
					/>
				</GroupItem>
				<GroupItem>
					<button onClick={this.onClickSearch} type="button" className="btn btn-info btn-block">
						<i className="fa fa-search" />
						&nbsp; Buscar
					</button>
				</GroupItem>
			</Form>
		);
	}
	renderForm() {
		return (
			<Form formData={this.user} ref={this.form} showColonAfterLabel={false} labelLocation={'left'}>
				<GroupItem colCount={5} caption={'Informações Básicas'}>
					<SimpleItem
						dataField={'id'}
						cssClass="uppercase"
						label={{ text: 'Código' }}
						editorOptions={{ disabled: true }}
					/>
					<SimpleItem dataField={'enabled'} editorType={'dxCheckBox'} label={{ text: 'Ativo' }} colSpan={4} />

					<SimpleItem colSpan={4} dataField={'name'} cssClass="uppercase" label={{ text: 'Nome' }} />
					<SimpleItem
						dataField={'document'}
						editorOptions={{
							mask: '000.000.000-00',
						}}
						cssClass="uppercase"
						label={{ text: 'CPF' }}
					/>
				</GroupItem>
				<GroupItem colCount={4} caption={'Informações de Acesso'}>
					<SimpleItem colSpan={3} dataField={'email'} label={{ text: 'E-mail', showColon: false }} />
					<SimpleItem
						dataField={'role'}
						editorType={'dxSelectBox'}
						cssClass="uppercase"
						editorOptions={{
							items: defaultData.userRoles,
							searchEnabled: true,
							searchModeOption: 'contains',
							searchTimeoutOption: 200,
							minSearchLengthOption: 2,
							showDataBeforeSearchOption: false,
						}}
						label={{ text: 'Perfil de Acesso' }}
					/>
				</GroupItem>
				<GroupItem colCount={3} caption={'Informações de Contato'}>
					<SimpleItem
						colSpan={3}
						dataField={'contactInformation.name'}
						cssClass="uppercase"
						label={{ text: 'Nome de Contato', showColon: false }}
					/>
					<SimpleItem
						dataField={'contactInformation.phoneNumber'}
						editorOptions={{
							mask: '(00) 00000-0000',
						}}
						label={{ text: 'Celular', showColon: false }}
					/>
					<SimpleItem
						dataField={'contactInformation.homePhoneNumber'}
						editorOptions={{
							mask: '(00) 0000-0000',
						}}
						label={{ text: 'Telefone Residencial', showColon: false }}
					/>
					<SimpleItem
						dataField={'contactInformation.businessPhoneNumber'}
						editorOptions={{
							mask: '(00) 0000-0000',
						}}
						label={{ text: 'Telefone Comercial', showColon: false }}
					/>
				</GroupItem>
				<GroupItem>
					<div className="pull-right">
						<button type="button" className="btn btn-right-space btn-primary" onClick={this.onClickNew}>
							<i className="fa fa-plus" />
							&nbsp; Novo
						</button>
						<button type="button" className="btn btn-success" onClick={this.onClickSave}>
							<i className="fa fa-check" />
							&nbsp; Salvar
						</button>
					</div>
				</GroupItem>
			</Form>
		);
	}
	render(props) {
		masterProps.form = this.renderForm();
		masterProps.dataGrid = this.renderGrid();
		masterProps.filter = this.renderFilter();
		return <CrudForm {...masterProps} ref={this.crudForm} />;
	}
}
